import React, { memo, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Button from "@mui/material/Button";
import {
  Card,
  CardContent,
  Grid,
  CardActions,
  TableRow,
  TableCell,
  Alert,
  Box,
  Dialog,
  DialogContent,
  Stack,
  Link,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import "../../styles/main.css";
import {
  preevaluacionCliente,
  preevaluacionClienteCredito,
} from "../../services/creditoServices";
import {
  obtenerPersonaCf,
  validarDocumentosCF,
} from "app/modules/app-cliente/services/clienteService";
import {
  grabarAceptacion,
  notificarAceptacion,
  obtenerAceptacion,
} from "app/modules/app-evaluacion/services/evaluacionServices";
import PoliticsDetails from "../../components/PoliticsDetails";
import { SCSGenericButton } from "app/modules/common/components/Buttons/SCSButtons";
import BuscadorPreevCliente from "../../containers/BuscadorPreevCliente";
import { consultarFechaSistema } from "app/modules/shared/services/sheredServices";
import { descargarArchivoStatic } from "app/modules/app-configuracion/services/configuracionServices";

function PreevaluacionContent() {
  const [mostrarAprobado, setMostrarAprobado] = useState(false);
  const [mostrarNegado, setMostrarNegado] = useState(false);
  const [identificacionCliente, setIdentificacionCliente] = useState("");
  const [mensajeCliente, setMensajeCiente] = useState("");
  const [mensajeClienteExpress, setMensajeCienteExpress] = useState("");
  const [terminosYCondiciones, setTerminosYCondiciones] = useState("");
  const [politicasPrivacidad, setpoliticasPrivacidad] = useState("");
  const [aceptadoTyC, setAceptadoTyC] = useState(false);
  const [aceptadoPPR, setAceptadoPPR] = useState(false);
  const [datosCli, setDatosCli] = useState({});
  const { authUser } = useSelector(({ auth }) => auth);
  const [openTYCC, setOpenTYCC] = useState(false);
  const [openTYC, setOpenTYC] = useState(false);
  const [openPPR, setOpenPPR] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingPreevaluar, setLoadingPreevaluar] = useState(false);
  const [loadingTyCButton, setLoadingTyCButton] = useState(false);

  const isSubmittingRef = useRef(false);

  const history = useHistory();

  const [statesLegalDocuments, setStatesLegalDocuments] = useState({
    stateTYC: false,
    statePPR: false,
  });

  const [openPoliticsDetails, setOpenPoliticsDetails] = useState(false);
  const [clientInformation, setClientInformation] = useState({});
  const [emailVerificacion, setEmailVerificacion] = useState({});
  const [flujoFinal, setFlujoFinal] = useState("");
  const [datosPreevaluacion, setDatosPreevaluacion] = useState({});

  const [open, setOpen] = useState(false); // puedes controlar esto desde fuera
  const [continuaProceso, setContinuaProceso] = useState(false);
  const [montoMG, setMontoMG] = useState(0);
  const [datosIniciales, setDatosIniciales] = useState({});

  const handleClose = (_, reason) => {
    // Esto permite cerrar tanto al hacer clic fuera como con ESC
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      setOpen(false);
    }
  };

  const handleCloseTYCC = (_, reason) => {
    setOpenTYCC(false);
    isSubmittingRef.current = false;
    setLoadingTyCButton(false);
  };

  const traerDatosPreev = (datos) => async () => {
    if (!datos.identificacion || datos.identificacion.length !== 10) {
      alert("Ingrese un numero de cédula valido");
    } else if (!datos.codDactilar) {
      alert("Ingrese un codigo dáctilar válido");
    } else if (!datos.celularCliente || datos.celularCliente.length !== 10) {
      alert("Ingrese un celular válido");
    } else if (!datos.mailCliente) {
      alert("Ingrese un correo electrónico valido");
    } else {
      setAceptadoTyC(false);
      setAceptadoPPR(false);
      setMostrarAprobado(false);
      setMostrarNegado(false);
      setIdentificacionCliente(datos.identificacion);
      //preevaluacionClienteSolicitud(datos);
      setDatosIniciales(datos);
      setOpenTYCC(true);
    }
  };

  const validarIdentificacionCF = (id) => async () => {
    if (!id) {
      alert("Ingrese un numero de cedula");
    } else {
      if (id.length === 10) {
        setMostrarAprobado(false);
        setMostrarNegado(false);
        setAceptadoTyC(false);
        setAceptadoPPR(false);
        validacionTyC(id);
      } else {
        alert("Ingrese un numero de cedula valido");
      }
    }
  };

  const validacionTyC = async (identificacion) => {
    setLoading(true);
    const today = new Date().toLocaleString("en-US");

    try {
      const respInfoAceptacion = await obtenerAceptacion(identificacion);

      if (respInfoAceptacion.state) {
        alert(
          "Cliente ya tiene firmado los documentos de Términos y Condiciones. Puede continuar",
        );

        setOpenPoliticsDetails(false);
        //setModalClient((args) => ({ ...args, state: false }));
        setStatesLegalDocuments((args) => ({
          ...args,
          statePPR: true,
          stateTYC: true,
        }));

        setAceptadoPPR(true);
        setAceptadoTyC(true);
        setLoading(false);

        return;
      }
    } catch (error) {
      console.log(error);
    }

    const cli = {
      identificacion: identificacion,
      fechaConsulta: today,
      idGrupo: authUser.usuarioFlujos[0].idGrupo,
      usuario: authUser.key,
      estacion: authUser.estacion,
      enviaDatos: false,
      tcu: false,
      ppr: false,
      bur: true,
      //esCliente:false
    };

    try {
      if (authUser.usuarioFlujos[0].idGrupo === 1) {
        const respObetenerPersona = await obtenerPersonaCf(identificacion);
        if (respObetenerPersona.state) {
          //setDatosCli({ cliente: respObetenerPersona.data.statePerson});
          cli.esCliente = respObetenerPersona.data.statePerson;
        } else {
          console.log(respObetenerPersona.message);
        }

        if (!cli.esCliente) {
          alert(
            "Cliente tiene pendiente la aceptacion de Términos y Condiciones",
          );

          /* permite activar los modales de los documentos legales e impide 
        la llamada a los servicio cuando no es necesario */
          setAceptadoTyC(true);
          setAceptadoPPR(true);

          /* cierra el modal de identificacion */
          // setModalClient((args) => ({ ...args, state: false }));

          /* settea los estados de los documentos */
          setStatesLegalDocuments((args) => ({
            ...args,
            statePPR: false,
            stateTYC: false,
          }));

          /* permite abrir el modal PoliticsDetails cuado es necesario firmar los documentos */
          setOpenPoliticsDetails(true);

          //return;
        }

        if (cli.esCliente) {
          const respValidarDocumentos =
            await validarDocumentosCF(identificacion);

          if (respValidarDocumentos.state) {
            const boolString = "true";

            cli.documentosFirmados =
              boolString === respValidarDocumentos.data.stateDocuments;

            if (cli.documentosFirmados) {
              alert(
                "Cliente ya tiene firmado los documentos de Términos y Condiciones. Puede continuar",
              );

              setOpenPoliticsDetails(false);
              setLoading(false);

              //setModalClient((args) => ({ ...args, state: false }));
              setStatesLegalDocuments((args) => ({
                ...args,
                statePPR: true,
                stateTYC: true,
              }));

              setAceptadoPPR(true);
              setAceptadoTyC(true);
            } else {
              alert(
                "Cliente tiene pendiente la aceptacion de Términos y Condiciones",
              );
              const documentos = respValidarDocumentos.data.documents;

              /* para habilitar los modales de politicas documents */
              setAceptadoPPR(true);
              setAceptadoTyC(true);

              if (documentos === null) {
                /* cierra el modal de identificacion */
                //setModalClient((args) => ({ ...args, state: false }));

                /* permite abrir el modal PoliticsDetails cuado es necesario firmar los documentos */
                setOpenPoliticsDetails(true);

                /* settea los estados de los documentos */
                setStatesLegalDocuments((args) => ({
                  ...args,
                  statePPR: false,
                  stateTYC: false,
                }));
              } else {
                if (documentos.length < 2) {
                  const tieneTCU = documentos.some(
                    (doc) => doc.contentType === "TCD",
                  );
                  const tienePPR = documentos.some(
                    (doc) => doc.contentType === "PPR",
                  );
                  if (!tieneTCU) {
                    setStatesLegalDocuments((args) => ({
                      ...args,
                      statePPR: false,
                      stateTYC: true,
                    }));
                  }

                  if (!tienePPR) {
                    setStatesLegalDocuments((args) => ({
                      ...args,
                      statePPR: true,
                      stateTYC: false,
                    }));
                  }

                  /* cierra el modal de identificacion */
                  //setModalClient((args) => ({ ...args, state: false }));

                  /* permite abrir el modal PoliticsDetails cuado es necesario firmar los documentos */
                  setOpenPoliticsDetails(true);
                } else {
                  setStatesLegalDocuments((args) => ({
                    ...args,
                    statePPR: false,
                    stateTYC: false,
                  }));

                  /* cierra el modal de identificacion */
                  //setModalClient((args) => ({ ...args, state: false }));

                  /* permite abrir el modal PoliticsDetails cuado es necesario firmar los documentos */
                  setOpenPoliticsDetails(true);
                }
              }
            }
          } else {
            alert(respValidarDocumentos.message);
          }
        }
      } else {
        cli.esCliente = false;
        cli.enviaDatos = true;
        alert(
          "Cliente tiene pendiente la aceptacion de Términos y Condiciones",
        );

        setAceptadoTyC(true);
        setAceptadoPPR(true);

        /* settea los estados de los documentos */
        setStatesLegalDocuments((args) => ({
          ...args,
          statePPR: false,
          stateTYC: false,
        }));

        setOpenPoliticsDetails(true);
      }
    } catch (e) {
      setOpenPoliticsDetails(true);

      console.log(e);
    }

    setClientInformation(cli);
  };

  const grabarDatosAceptacion = async () => {
    let today = null;
    const srvFecha = await consultarFechaSistema();
    if (srvFecha.state) {
      today = srvFecha.data.fechaHora;
    } else {
      today = new Date().toLocaleString("en-US");
    }
    const datosAceptacion = {
      Identificacion: datosIniciales.identificacion,
      FechaConsulta: today,
      IdGrupo: authUser.usuarioFlujos[0].idGrupo,
      Usuario: authUser.key,
      Estacion: authUser.estacion,
      EnviaDatos: false,
      Tcu: true,
      Ppr: true,
      Bur: true,
      EsCliente: false,
      DocumentosFirmados: false,
      Email: datosIniciales.mailCliente,
    };
    try {
      const srvGrabarAceptacion = await grabarAceptacion(datosAceptacion);
      if (srvGrabarAceptacion.state) {
        console.log(srvGrabarAceptacion.data);
        handleNotificarTyC(datosAceptacion.Email);
      } else {
        alert(srvGrabarAceptacion.message);
      }
    } catch (e) {
      alert(e);
    }
  };

  const handleNotificarTyC = async (email) => {
    const nombreArchivo =
      authUser.usuarioFlujos[0].idGrupo === 1
        ? "TYC_PPR_CORPFAV.pdf"
        : "TYC_PPR_TVENTAS.pdf";

    const srvObtenerPdf = await descargarArchivoStatic(nombreArchivo);

    if (srvObtenerPdf.state) {
      const base64Document = srvObtenerPdf.data;

      const notificacion = {
        email: email,
        documentosBase64: base64Document,
      };
      try {
        const resp = await notificarAceptacion(notificacion);
        console.log(resp);
      } catch (e) {
        console.log(e);
      }
    }
  };

  const validacionInicialCliente = async (identificacion) => {
    setLoadingPreevaluar(true);
    const validarBuro = true;
    try {
      var resp = await preevaluacionCliente(
        identificacion,
        authUser.key,
        authUser.estacion,
        validarBuro,
      );
      if (resp.state) {
        console.log(resp);
        if (resp.state) {
          if (resp.data.validacion) {
            //console.log(resp.data.mensaje);
            setMensajeCiente(resp.data.mensaje);
            setMostrarAprobado(true);
            setLoadingPreevaluar(false);
          } else {
            setMensajeCiente(resp.data.mensaje);
            setMostrarNegado(true);
            setLoadingPreevaluar(false);
          }
        } else {
          console.log(resp.message);
          setLoadingPreevaluar(false);
        }
      }
    } catch (e) {
      console.log(e);
      setLoadingPreevaluar(false);
    }
  };

  const preevaluacionClienteSolicitud = async (datos) => {
    console.log(datos);

    setLoadingPreevaluar(true);

    const validarBuro = true;
    const datosPreev = {
      identificacion: datos.identificacion,
      usuario: authUser.key,
      local: authUser.oficina,
      origen: "SCS",
      dactilar: datos.codDactilar,
      celular: datos.celularCliente,
      email: datos.mailCliente,
      estacion: authUser.estacion,
    };

    try {
      var resp = await preevaluacionClienteCredito(datosPreev);
      if (resp.state) {
        // console.log(resp);
        const flujoRespuesta = resp.data.datosPreevaluacion.flujoFinal;
        setFlujoFinal(resp.data.datosPreevaluacion.flujoFinal);
        //setMontoSugerido(resp.data.datosMontoSugerido.valor)
        setDatosPreevaluacion(resp.data);
        let monto, montoAbastos;
        switch (flujoRespuesta) {
          case "NEGADO":
            setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
            setMostrarNegado(true);
            setLoadingPreevaluar(false);
            setContinuaProceso(false);
            setOpen(true);

            break;
          case "REVISION":
            monto =
              resp.data.datosMontoSugerido.valor > 2500
                ? 2500
                : resp.data.datosMontoSugerido.valor < 0
                  ? 0
                  : resp.data.datosMontoSugerido.valor;

            setMensajeCiente(
              "¡Felicitaciones! Estás a un paso de tener tu Crédito Favorito. Ahora solo falta que completes una validación corta para finalizar el proceso y dejar tu crédito listo para usar",
            );
            setMostrarAprobado(true);
            setLoadingPreevaluar(false);
            setContinuaProceso(true);
            setOpen(true);

            break;
          case "EXPRESS":
            setMontoMG(
              resp.data.datosMontoSugerido.valor > 2500
                ? 2500
                : resp.data.datosMontoSugerido.valor < 0
                  ? 0
                  : resp.data.datosMontoSugerido.valor.toFixed(0),
            );
            monto =
              resp.data.datosMontoSugerido.valor > 2500
                ? 2500
                : resp.data.datosMontoSugerido.valor < 0
                  ? 0
                  : resp.data.datosMontoSugerido.valor.toFixed(0);

            montoAbastos = resp.data.datosMontoSugerido.valorAbastos;
            const textAbastos =
              resp.data.datosPreevaluacion.idGrupo === 1
                ? ` y para Abastos de $${montoAbastos.toFixed(0)}`
                : ``;
            setMensajeCiente(
              `Felicidades tienes un monto aprobado para Mercancias Generales de $${monto}${textAbastos} y puedes usarlos hoy mismo.`,
            );
            setMensajeCienteExpress(
              `Solo te faltan 2 pasos para activarlo y empezar a comprar, Confirma tu identidad y Personaliza las condiciones de tu crédito`,
            );
            setMostrarAprobado(true);
            setLoadingPreevaluar(false);
            setContinuaProceso(true);
            setOpen(true);

            break;
          case "DEVUELTA":
            setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
            setMostrarAprobado(true);
            setLoadingPreevaluar(false);
            setContinuaProceso(true);
            setOpen(true);

            break;
          case "SolicitudActiva":
            setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
            setMostrarNegado(true);
            setLoadingPreevaluar(false);
            setContinuaProceso(false);
            setOpen(true);

            break;
          default:
            setMensajeCiente(
              "En estos momentos no podemos realizar su Evaluación por favor intente en unos minutos.",
            );
            setMostrarNegado(true);
            setLoadingPreevaluar(false);
            setContinuaProceso(false);
            setOpen(true);

            break;
        }

        // if (resp.data.validacion) {
        //   //console.log(resp.data.mensaje);
        //   setMensajeCiente(resp.data.mensaje);
        //   setMostrarAprobado(true);
        //   setLoadingPreevaluar(false);
        // } else {
        //   setMensajeCiente(resp.data.mensaje);
        //   setMostrarNegado(true);
        //   setLoadingPreevaluar(false);
        // }
      } else {
        console.log(resp.message);
        setMensajeCiente(
          "En estos momentos no podemos realizar su Evaluación por favor intente en unos minutos.(P)",
        );
        setLoadingPreevaluar(false);
        setContinuaProceso(false);
        setOpen(true);
      }
    } catch (e) {
      console.log(e);
      setMensajeCiente(
        "En estos momentos no podemos realizar su Evaluación por favor intente en unos minutos.(E)",
      );
      setLoadingPreevaluar(false);
      setContinuaProceso(false);
      setOpen(true);
    }
  };

  const routeChange = (cambioCupo) => {
    const path = "/credito/flujop";
    history.push(path, {
      data: {
        identificacion: identificacionCliente,
        flujoFinal: flujoFinal,
        cambioCupo: cambioCupo,
        datosPreevaluacion: datosPreevaluacion,
      },
    });
  };

  useEffect(() => {
    if (aceptadoPPR & aceptadoTyC) {
      //grabarDatosAceptacion();
      console.log(datosCli);
    }
  }, [datosCli]);

  const limpiar = (valor) => async () => {
    console.log(valor);
    //setLimpiar(valor);
    //setOpenTyC(false);
  };

  const handleCloseModalTYC = () => {
    setOpenTYCC(false);
    isSubmittingRef.current = false; 
  };

  if (!authUser.usuarioFlujos[0]) {
    return (
      <Alert severity="error">
        <Typography>
          Estimado Usuario, usted no puede crear solicitudes de crédito, para
          mayor información comunicarse con Soporte Técnico - Servimax.
        </Typography>
      </Alert>
    );
  }

  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Grid
          rowSpacing={4}
          spacing={5}
          justifyContent="center"
          alignItems={"center"}
          width={{ xs: 1, md: "80%", lg: "60%", xl: "50%" }}
        >
          <Grid item md={7} sm={7} xs={7}>
            <BuscadorPreevCliente
              traerDatosPreev={traerDatosPreev}
              // traerIdentificacion={traerIdentificacion}
              validarIdentificacionCF={validarIdentificacionCF}
              validado={aceptadoPPR & aceptadoTyC}
              limpiar={limpiar}
              loading={loading}
              loadingPreevaluar={loadingPreevaluar}
              idGrupo={authUser.usuarioFlujos[0].idGrupo}
            />
          </Grid>
        </Grid>
        {/* <PoliticsDetails
          open={openPoliticsDetails}
          setOpenPoliticsDetails={setOpenPoliticsDetails}
          titulo={"Politicas de Credito Directo"}
          aceptadoTyC={aceptadoTyC}
          aceptadoPPR={aceptadoPPR}
          statesLegalDocuments={statesLegalDocuments}
          clientInformation={clientInformation}
          setLoadButtonTYC={setLoading}
          setAceptadoPPR={setAceptadoPPR}
          setAceptadoTyC={setAceptadoTyC}
        /> */}
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: 4,
            overflow: "hidden",
          },
        }}
      >
        <DialogContent
          sx={{
            backgroundColor: "#e9f0ffff",
            borderRadius: 4,
            p: 3,
          }}
        >
          <Card
            elevation={0}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
          >
            <CardContent>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
              >
                <Box flex="1" minWidth="220px">
                  <Typography
                    variant="h2"
                    fontWeight="bold"
                    color="text.primary"
                    // gutterBottom
                  >
                    {continuaProceso
                      ? "EVALUACION EXITOSA"
                      : "EVALUACION NO EXITOSA"}
                  </Typography>
                  <Typography variant="h3" color="text.secondary" mb={2} mt={5}>
                    {mensajeCliente}
                  </Typography>
                  <Typography variant="h3" color="text.secondary" mb={2} mt={5}>
                    {mensajeClienteExpress}
                  </Typography>
                  {continuaProceso && (
                    <Stack direction={"row"} spacing={2} mt={8}>
                      <Button
                        variant="contained"
                        onClick={() => {
                          routeChange(false);
                        }}
                        sx={{
                          backgroundColor: "#FFFFFF",
                          color: "#000",
                          textTransform: "none",
                          fontWeight: "bold",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                          "&:hover": { backgroundColor: "#f5f5f5" },
                          borderRadius: "9999px", // 🔘 redondeado tipo píldora
                          px: 3, // padding horizontal extra
                          "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                      >
                        Continuar
                      </Button>
                    </Stack>
                  )}
                </Box>

                {/* Imagen del personaje rojo */}
                <Box
                  component="img"
                  src={`/images/logo-preev-${authUser.usuarioFlujos[0].idGrupo}.png`}
                  alt="Figura roja"
                  sx={{
                    width: 175,
                    height: "auto",
                    ml: 2,
                    mt: { xs: 2, sm: 0 },
                  }}
                />
              </Box>
            </CardContent>
          </Card>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openTYCC}
        onClose={handleCloseTYCC}
        fullWidth
        maxWidth="lg"
        PaperProps={{
          sx: {
            borderRadius: 4,
            overflow: "hidden",
          },
        }}
      >
        <DialogContent
          sx={{
            backgroundColor: "#e9f0ffff",
            borderRadius: 4,
            p: 3,
          }}
        >
          <Card
            elevation={0}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
          >
            <CardContent>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
              >
                <Box flex="1" minWidth="220px">
                  <Stack spacing={3}>
                    <Typography
                      variant="h1"
                      fontWeight="bold"
                      color="text.primary"
                      // gutterBottom
                    >
                      Por favor lee y acepta los siguientes términos.
                    </Typography>
                    <Typography
                      variant="h3"
                      color="text.primary"
                      // gutterBottom
                    >
                      1. Buró y Fuentes de Información
                    </Typography>
                    <Typography sx={{ textAlign: "justify" }}>
                      Autorizo expresamente a Corporación Favorita C.A.,
                      Servimax Servicios Globales S.A. y a los cesionarios,
                      beneficiarios, acreedores o terceros autorizados que esta
                      designe, para que obtengan, registren, almacenen,
                      transfieran o entreguen mi información de riesgos
                      crediticios, las veces que sea necesario, la cual puede
                      incluir mi comportamiento, historial o perfil crediticio
                      en entidades públicas o privadas, a cualquier fuente de
                      información, incluyendo burós de información crediticia
                      y/u otras fuentes legalmente habilitadas. De igual forma,
                      autorizo expresamente para que se consulte y valide mi
                      información en fuentes públicas, incluyendo el Registro
                      Civil u otras bases públicas habilitadas. Esta consulta
                      tendrá como finalidad verificar mi identidad y validar la
                      información proporcionada;
                    </Typography>
                    <Typography
                      variant="h3"
                      color="text.primary"
                      // gutterBottom
                    >
                      2. Aviso de Privacidad y Firma Electrónica
                    </Typography>
                    <Typography sx={{ textAlign: "justify" }}>
                      Declaro que he sido informado sobre el tratamiento de mis
                      datos personales conforme el Aviso de Privacidad{" "}
                      <Link
                        href="https://creditofavorito.com/politica-de-privacidad-corporacion-favorita-c-a/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Credito Favorito
                      </Link>{" "}
                      puesto a mi disposición. Asimismo, otorgo mi
                      consentimiento expreso, libre e informado para aquellos
                      tratamientos que requieran mi autorización, incluyendo los
                      necesarios para evaluar, gestionar y ejecutar mi
                      solicitud. Adicionalmente, autorizo expresamente a
                      Corporación Favorita C.A. y a Servimax Servicios Globales
                      S.A. para gestionar la obtención de mi firma electrónica
                      mediante un proveedor autorizado, así como para utilizar y
                      entregar la información necesaria para dicho fin.
                      Asimismo, otorgo mi consentimiento explícito para el
                      tratamiento de los datos biométricos requeridos para
                      validar mi identidad, incluida mi imagen facial o prueba
                      de vida, exclusivamente para la emisión de la firma
                      electrónica;
                    </Typography>
                    <Typography
                      variant="h3"
                      color="text.primary"
                      // gutterBottom
                    >
                      3. Referencias personales
                    </Typography>
                    <Typography sx={{ textAlign: "justify" }}>
                      Me encuentro autorizado para proporcionar los datos de las
                      referencias incluidas en el proceso, y que he informado a
                      dichas personas que podrán ser contactadas por la
                      compañía, directamente o a través de terceros autorizados,
                      para fines de verificación de información, validación de
                      identidad, actualización de datos, localización, gestión
                      comercial, y, en caso de mora o incumplimiento, procesos
                      de cobranza.
                    </Typography>
                    <Button
                      variant="contained"
                      disabled={loadingTyCButton}
                      onClick={async () => {
                        // 1. Si ya se está enviando, no hagas nada
                        if (isSubmittingRef.current) return;
                        isSubmittingRef.current = true;

                        setLoadingTyCButton(true);

                        try {
                          await grabarDatosAceptacion();
                          await preevaluacionClienteSolicitud(datosIniciales);

                          handleCloseTYCC();
                        } catch (error) {
                          isSubmittingRef.current = false;
                          setLoadingTyCButton(false);
                        }
                      }}
                      sx={{
                        backgroundColor: "#FFFFFF",
                        color: "#000",
                        textTransform: "none",
                        fontWeight: "bold",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                        "&:hover": { backgroundColor: "#f5f5f5" },
                        borderRadius: "9999px", // 🔘 redondeado tipo píldora
                        px: 3, // padding horizontal extra
                        "&:hover": { backgroundColor: "#f5f5f5" },
                      }}
                    >
                      Aceptar y Continuar
                    </Button>
                  </Stack>
                </Box>

                {/* Imagen del personaje rojo */}
                <Box
                  component="img"
                  src={`/images/logo-preev-${authUser.usuarioFlujos[0].idGrupo}.png`}
                  alt="Figura roja"
                  sx={{
                    width: 125,
                    height: "auto",
                    ml: 2,
                    mt: { xs: 2, sm: 0 },
                  }}
                />
              </Box>
            </CardContent>
          </Card>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default memo(PreevaluacionContent);
